import React from 'react';
import { useStyleConfig, Text, Flex } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IChakraButtonProps } from './interfaces';

const ChakraButton: FCWithChildren<IChakraButtonProps> = ({
  size = 'md',
  variant = 'primary',
  onClick,
  faIconName,
  children,
  ...rest
}) => {
  const styles = useStyleConfig('ButtonTheme', { size, variant });

  return (
    <Flex
      justify="center"
      align="center"
      as="a"
      onClick={onClick}
      sx={styles}
      {...rest}
    >
      {faIconName && <FontAwesomeIcon icon={faIconName} />}
      <Text mb={0} ml={faIconName ? 3 : 0}>
        {children}
      </Text>
    </Flex>
  );
};

export default ChakraButton;
